import { RigidTrailerType, TrailerType, WincantonTrailerTypes } from '../global/enums/TrailerType';
import { SpecialEquipment } from '../global/enums/SpecialEquipment';
import { RigidAndArticTrailerType } from '../global/types/RigidAndArticTrailerType';

export const trailerFunctions = {
  _trailerTypeToStringMap: new Map<RigidAndArticTrailerType | WincantonTrailerTypes, string>([
    [TrailerType.TAUTLINER_13_6M_44FT, '13.6m/44ft Curtainsider/Tautliner'],
    [TrailerType.MEGA_TRAILER_13_6M_44FT, '13.6m/44ft Mega trailer'],
    [TrailerType.BOX_13_6M_44FT, '13.6m/44ft Box'],
    [TrailerType.REFRIGERATOR_13_6M_44FT, '13.6m/44ft Refrigerator'],
    [TrailerType.FLATBED_13_6M_44FT, '13.6m/44ft Flatbed'],
    [TrailerType.DOUBLE_DECKER_13_6M_44FT, '13.6m/44ft Double Decker'],
    [TrailerType.HIGH_CUBE_OR_TALL_TRAILER, 'High Cube/Tall Trailer'],
    [TrailerType.CONTAINER_13_6M_44FT, '13.6m/44ft Container'],
    [TrailerType.HC_CONTAINER_5_9M_20FT, '5.9m/20ft HC Container'],
    [TrailerType.CONTAINER_12M_40FT, '12m/40ft Container'],
    [TrailerType.HC_CONTAINER_12M_40FT, '12m/40ft HC Container'],
    [TrailerType.HC_CONTAINER_13_6M_45FT, '13.6m/45ft HC Container'],
    [TrailerType.MEGA_BOX_13_6M_44FT, '13.6m/45ft Mega Box'],
    [RigidTrailerType.RIGID_26T, '26t Rigid'],
    [RigidTrailerType.RIGID_18T, '18t Rigid'],
    [RigidTrailerType.RIGID_7_5T, '7.5t Rigid'],
    [RigidTrailerType.RIGID_TANDEM_JUMBO, 'Rigid Tandem Jumbo'],
    [WincantonTrailerTypes.TRACTION, 'Traction'],
    [WincantonTrailerTypes.TALL_BOY_TRAILER, 'Tall Boy Trailer'],
    [WincantonTrailerTypes.ARTIC_CRANE, 'Artic Crane'],
    [WincantonTrailerTypes.BOX_TRAILER, 'Box Trailer'],
    [WincantonTrailerTypes.BULK_TIPPER, 'Bulk Tipper'],
    [WincantonTrailerTypes.CURTAIN_SIDE_TRAILER, 'Curtain Side Trailer'],
    [WincantonTrailerTypes.DOUBLE_DECK_TRAILER, 'Double Deck Trailer'],
    [WincantonTrailerTypes.DRAW_BAR, 'Draw Bar'],
    [WincantonTrailerTypes.DRAW_BAR_26_3_MAX, 'Draw Bar 26.3 Max'],
    [WincantonTrailerTypes.DRAW_BAR_FLAT, 'Draw Bar Flat'],
    [WincantonTrailerTypes.DRAW_BAR_MOFFETT, 'Draw Bar Moffett'],
    [WincantonTrailerTypes.DRAW_BAR_CRANE, 'Draw Bar Crane'],
    [WincantonTrailerTypes.FLAT_BED_TRAILER, 'Flat Bed Trailer'],
    [WincantonTrailerTypes.MOFFETT, 'Moffett'],
    [WincantonTrailerTypes.MOL, 'Mol'],
    [WincantonTrailerTypes.PALLET_CARRIER, 'Pallet Carrier'],
    [WincantonTrailerTypes.POWDER_TANKER, 'Powder Tanker'],
    [WincantonTrailerTypes.URBAN_ARTIC_CRANE, 'Urban Artic Crane'],
    [WincantonTrailerTypes.WALKING_FLOOR, 'Walking Floor'],
  ]),

  _specialEquipmentToStringMap: new Map([
    [SpecialEquipment.NONE, 'None'],
    [SpecialEquipment.MOFFETT, 'Moffet'],
    [SpecialEquipment.HI_AB, 'Hi-Ab'],
  ]),

  trailerTypeToString: (value: RigidAndArticTrailerType | WincantonTrailerTypes): string => {
    return trailerFunctions._trailerTypeToStringMap.get(value);
  },
  specialEquipmentToString: (value: SpecialEquipment): string => {
    return trailerFunctions._specialEquipmentToStringMap.get(value);
  },
};
